module.exports = __webpack_public_path__ + "static/media/hero4.e1f8ea13.png";